"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHelpCircleOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 26a12 12 0 1112-12 12 12 0 01-12 12z" }),
        React.createElement("path", { d: "M16 21a1.5 1.5 0 101.53 1.49A1.49 1.49 0 0016 21zM16 8c-2.41 0-3.36 1.27-3.72 2.34a5.56 5.56 0 00-.28 1.8h2a3.53 3.53 0 01.16-1.14c.17-.49.52-1 1.83-1 1.48 0 2 .56 2 2.15s-.45 1.86-1.13 2.32A3.66 3.66 0 0015 18v1h2v-1a1.75 1.75 0 011-1.88c.85-.57 2-1.36 2-4S18.58 8 16 8z" })));
}
exports.default = SvgHelpCircleOutline;
//# sourceMappingURL=HelpCircleOutline.js.map